import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { Col, Form, Row, Select } from 'antd';
import comptroller from 'assets/images/comptroller_white.svg';
import CustomInputLabel from 'components/Label/CustomInputLabel';
import FormSubmitButton from 'components/button/FormSubmitButton';
import CustomSelectInput from 'components/inputs/CustomSelectInput';
import ComptrollerModalContainer from 'components/modal/ComptrollerModalContainer';
import { useAddServiceLevelMutation } from 'store/features/comptroller/comptrollerApi';

export const taskNatureData = [
	{ id: 1, label: 'Action', value: 'Action' },
	{ id: 2, label: 'Decision', value: 'Decision' },
];

export const timelineBasisData = [
	{ id: 1, label: '5 Days a Week', value: 5 },
	{ id: 2, label: '7 Days a Week', value: 7 },
];

export const triggeringActionData = [
	{ id: 2, label: 'Approve', value: 'Approve' },
	{ id: 4, label: 'Reject', value: 'Reject' },
	{ id: 1, label: 'Wait', value: 'Wait' },
	{ id: 5, label: 'Send Back', value: 'Send_Back' },
	{ id: 3, label: 'Escalate', value: 'Escalate' },
];

const ServiceLevelAgreementCreateModal = ({ setOpenCreateModal, setReloadTable }) => {
	const [form] = Form.useForm();

	const [submitForm, setSubmitForm] = useState(false);

	const [submitData, setSubmitData] = useState(null);
	const [screenSize, setScreenSize] = useState('lg');
	const [confirmModal, setConfirmModal] = useState(false);

	const [AddServiceLevel, { isSuccess: isAddSuccess, isError: isAddFailed }] = useAddServiceLevelMutation();

	const handleClose = () => {
		setOpenCreateModal(false);
	};

	const submitHandle = (formData) => {
		AddServiceLevel(formData);
	};

	const handleModalSubmit = (data) => {
		setSubmitData(data);
		setConfirmModal(true);
	};

	useEffect(() => {
		if (isAddSuccess) {
			toast.success('Success! Action completed.', toastConfig);

			setReloadTable((prev) => !prev);
			setOpenCreateModal(false);
		} else if (isAddFailed) {
			setSubmitData(null);
			toast.error('Failure! Action not completed.', toastConfig);
		}
	}, [isAddSuccess, isAddFailed]);

	useEffect(() => {
		if (submitForm && submitData) {
			submitHandle(submitData);

			setReloadTable((prev) => !prev);
		}
	}, [submitForm]);

	return (
		<ComptrollerModalContainer
			form={form}
			viewType={false}
			showModal={true}
			screenSize={screenSize}
			title="Create Service Level Agreement"
			handleClose={handleClose}
			confirmModal={confirmModal}
			setScreenSize={setScreenSize}
			onFieldsChange={() => {}}
			handleSubmit={handleModalSubmit}
			setConfirmModal={setConfirmModal}
			handleDeactivate={() => setSubmitForm(true)}
			modalData={{
				head: 'Service Level Agreement',
				label: 'Do you want to create',
			}}
		>
			<Row gutter={[16, 0]} style={{ marginTop: '12px', marginBottom: '20px' }}>
				<Col xs={24}>
					<CustomSelectInput
						form={form}
						name="taskType"
						label="Task Nature"
						rules={[
							{
								required: true,
								message: 'Field is required',
							},
						]}
					>
						{taskNatureData.map((value, index) => (
							<Select.Option key={index} value={value?.value}>
								{value?.label}
							</Select.Option>
						))}
					</CustomSelectInput>
				</Col>

				<Col xs={24}>
					<CustomSelectInput
						form={form}
						name="dayCount"
						label="Timeline Basis"
						rules={[
							{
								required: true,
								message: 'Field is Required',
							},
						]}
					>
						{timelineBasisData.map((value, index) => (
							<Select.Option key={index} value={value?.value}>
								{value?.label}
							</Select.Option>
						))}
					</CustomSelectInput>
				</Col>

				<Col xs={24}>
					<CustomSelectInput
						form={form}
						name="action"
						label="SLA Triggering Action"
						rules={[
							{
								required: true,
								message: 'Field is Required',
							},
						]}
					>
						{triggeringActionData.map((value, index) => (
							<Select.Option key={index} value={value?.value}>
								{value?.label}
							</Select.Option>
						))}
					</CustomSelectInput>
				</Col>

				<Col xs={24} sm={24} md={24} xl={24}>
					<FormSubmitButton />
				</Col>
			</Row>
		</ComptrollerModalContainer>
	);
};

export default ServiceLevelAgreementCreateModal;
